import React, { useEffect } from 'react';
import PublicPageLayout from '../components/PublicPageLayout';

const PrivacyPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Privacy Statement - Solofix';
    window.scrollTo(0, 0);
  }, []);

  return (
    <PublicPageLayout title="PRIVACY STATEMENT SOLOFIX.NL">
        <div className="max-w-none text-fg-body">
          <p className="text-sm text-fg-muted italic mb-8">Laatste update: 14-08-2025</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">1. Inleiding</h2>
          <p className="mb-4">Dit privacy statement is van toepassing op de verwerking van persoonsgegevens door Solofix.nl ("Solofix", "wij", "ons"), onderdeel van Du Preez Creaties. Wij respecteren je privacy en zorgen ervoor dat je persoonsgegevens vertrouwelijk en in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG/GDPR) worden behandeld.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">2. Verantwoordelijke</h2>
          <p className="mb-2"><strong>Du Preez Creaties</strong></p>
          <p className="mb-2">Email: info@solofix.nl</p>
          <p className="mb-4">KvK-nummer: 84894814</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">3. Welke gegevens verzamelen wij?</h2>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">3.1 Account gegevens</h3>
          <p className="mb-2">Bij het aanmaken van een account verzamelen wij:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>E-mailadres</li>
            <li>Gebruikersnaam (zelf gekozen, geen echte naam vereist)</li>
            <li>Leeftijd</li>
            <li>Wachtwoord (veilig versleuteld opgeslagen)</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">3.2 Profiel gegevens (optioneel)</h3>
          <p className="mb-2">Je kunt vrijwillig de volgende informatie toevoegen:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Profielfoto</li>
            <li>Biografie</li>
            <li>Middelenvoorkeur (voor het vinden van passende groepen)</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">3.3 Gebruiksgegevens</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Groepslidmaatschappen</li>
            <li>Chatberichten (groeps- en individuele chats)</li>
            <li>Aangemaakte evenementen</li>
            <li>Betaal- en donatiegeschiedenis</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">3.4 Technische gegevens</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>IP-adres</li>
            <li>Browser type</li>
            <li>Apparaat informatie</li>
            <li>Geanonimiseerde bezoekersstatistieken via Google Analytics</li>
          </ul>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">4. Waarvoor gebruiken wij je gegevens?</h2>
          <p className="mb-4">Wij verwerken je persoonsgegevens voor de volgende doeleinden:</p>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">4.1 Dienstverlening</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Het aanmaken en beheren van je account</li>
            <li>Het mogelijk maken van groepsvorming voor evenementen</li>
            <li>Het faciliteren van communicatie tussen gebruikers</li>
            <li>Het verwerken van steunbetalingen en donaties</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">4.2 Veiligheid</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Het waarborgen van een veilige omgeving</li>
            <li>Het onderzoeken van meldingen van misbruik</li>
            <li>Het voorkomen van fraude en misbruik</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">4.3 Communicatie</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Het versturen van service-emails (wachtwoord reset, betaalbevestigingen)</li>
            <li>Het informeren over belangrijke wijzigingen</li>
            <li>Het versturen van herinneringen over evenementen (1 dag van tevoren)</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">4.4 Verbetering</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Het analyseren van geanonimiseerde gebruiksstatistieken</li>
            <li>Het verbeteren van de gebruikerservaring</li>
            <li>Het oplossen van technische problemen</li>
          </ul>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">5. Grondslagen voor verwerking</h2>
          <p className="mb-2">Wij verwerken je gegevens op basis van:</p>
          <ul className="list-disc ml-6 mb-4">
            <li><strong>Overeenkomst</strong>: Voor het leveren van onze diensten</li>
            <li><strong>Toestemming</strong>: Voor optionele profielgegevens en communicatie</li>
            <li><strong>Gerechtvaardigd belang</strong>: Voor veiligheid en fraudepreventie</li>
            <li><strong>Wettelijke verplichting</strong>: Indien wettelijk vereist</li>
          </ul>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">6. Met wie delen wij gegevens?</h2>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">6.1 Wij delen GEEN gegevens met:</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Adverteerders</li>
            <li>Data brokers</li>
            <li>Social media platforms</li>
            <li>Andere commerciële partijen</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">6.2 Wij delen alleen gegevens met:</h3>
          <ul className="list-disc ml-6 mb-4">
            <li><strong>Andere gebruikers</strong>: Alleen wat je zelf deelt in je profiel en chats</li>
            <li><strong>Mollie</strong>: Voor het verwerken van betalingen (alleen noodzakelijke transactiegegevens)</li>
            <li><strong>Strato</strong>: Onze hosting provider (onder verwerkersovereenkomst)</li>
            <li><strong>Google Analytics</strong>: Alleen geanonimiseerde bezoekersstatistieken</li>
            <li><strong>Autoriteiten</strong>: Alleen indien wettelijk verplicht bij strafbare feiten</li>
          </ul>
          <p className="mb-4">Wij verkopen NOOIT je gegevens aan derden.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">7. Beveiliging</h2>
          <p className="mb-2">Wij nemen passende technische en organisatorische maatregelen:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>HTTPS-versleuteling voor alle dataverkeer</li>
            <li>Veilige opslag van wachtwoorden met moderne encryptietechnologie</li>
            <li>Regelmatige beveiligingsupdates</li>
            <li>Beperkte toegang tot persoonsgegevens</li>
            <li>Hosting bij een betrouwbare Europese provider (Strato)</li>
          </ul>
          <p className="mb-4">Ondanks onze inspanningen kunnen wij geen absolute veiligheid garanderen. Bij een datalek informeren wij je conform wettelijke vereisten.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">8. Bewaartermijnen</h2>
          <ul className="list-disc ml-6 mb-4">
            <li><strong>Actieve accounts</strong>: Gegevens worden bewaard zolang je account actief is</li>
            <li><strong>Inactieve accounts</strong>: Na 3 jaar inactiviteit krijg je een waarschuwing, daarna kan je account worden verwijderd</li>
            <li><strong>Na accountverwijdering</strong>: Alle gegevens worden direct en permanent verwijderd</li>
            <li><strong>Financiële gegevens</strong>: Transactiegegevens bewaren wij 7 jaar conform wettelijke vereisten</li>
            <li><strong>Bij misbruik</strong>: Relevante gegevens kunnen langer bewaard worden indien nodig voor juridische procedures</li>
          </ul>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">9. Cookies</h2>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">9.1 Functionele cookies</h3>
          <p className="mb-2">Essentieel voor het functioneren van de website:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Inlogstatus behouden</li>
            <li>Taalvoorkeuren</li>
            <li>Beveiligingscookies</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">9.2 Analytische cookies</h3>
          <ul className="list-disc ml-6 mb-4">
            <li>Google Analytics (geanonimiseerd)</li>
            <li>Voor het meten van bezoekersaantallen en gebruikspatronen</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">9.3 Geen tracking cookies</h3>
          <p className="mb-2">Wij gebruiken geen:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Advertentiecookies</li>
            <li>Social media tracking cookies</li>
            <li>Profiling cookies van derden</li>
          </ul>
          <p className="mb-4">Je kunt cookies blokkeren via je browserinstellingen, maar dit kan de functionaliteit beperken.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">10. Je rechten</h2>
          <p className="mb-4">Onder de AVG heb je de volgende rechten:</p>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">10.1 Inzage</h3>
          <p className="mb-4">Je kunt inzage vragen in de gegevens die wij van je verwerken.</p>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">10.2 Correctie</h3>
          <p className="mb-4">Je kunt onjuiste gegevens laten corrigeren via je accountinstellingen of door contact met ons op te nemen.</p>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">10.3 Verwijdering</h3>
          <p className="mb-2">Je kunt verzoeken om verwijdering van je account en alle bijbehorende gegevens. Let op:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Verwijdering gebeurt door een administrator na verificatie</li>
            <li>Bij verwijdering vervallen alle betalingen zonder restitutie</li>
            <li>Je kunt daarna geen nieuw account aanmaken met hetzelfde e-mailadres</li>
          </ul>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">10.4 Beperking</h3>
          <p className="mb-4">Je kunt verzoeken om beperking van de verwerking in bepaalde gevallen.</p>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">10.5 Bezwaar</h3>
          <p className="mb-4">Je kunt bezwaar maken tegen bepaalde verwerkingen.</p>

          <h3 className="text-xl font-semibold text-fg-bright mt-6 mb-3">10.6 Klacht</h3>
          <p className="mb-4">Je hebt het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens.</p>

          <p className="mb-4">Voor het uitoefenen van je rechten kun je contact opnemen via info@solofix.nl. Wij reageren binnen 4 weken.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">11. Gegevens van minderjarigen</h2>
          <p className="mb-4">Solofix is alleen toegankelijk voor personen van 18 jaar en ouder. Wij verzamelen niet bewust gegevens van minderjarigen. Als wij ontdekken dat een minderjarige een account heeft aangemaakt, verwijderen wij dit account.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">12. Internationale doorgifte</h2>
          <p className="mb-4">Je gegevens worden opgeslagen op servers binnen de Europese Economische Ruimte (EER). Wij maken geen gebruik van diensten die gegevens buiten de EER verwerken, met uitzondering van Google Analytics waarbij passende waarborgen zijn getroffen.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">13. Wijzigingen</h2>
          <p className="mb-4">Wij kunnen dit privacy statement wijzigen. Significante wijzigingen worden via e-mail of een melding op het platform gecommuniceerd. De laatste wijzigingsdatum staat bovenaan dit document.</p>

          <h2 className="text-2xl font-bold text-fg-bright mt-8 mb-4">14. Contact</h2>
          <p className="mb-4">Voor vragen over dit privacy statement of je persoonsgegevens kun je contact opnemen:</p>
          <p className="mb-2"><strong>Du Preez Creaties</strong></p>
          <p className="mb-2">Email: info@solofix.nl</p>
          <p className="mb-4">KvK-nummer: 84894814</p>
          <p className="mb-8">Voor privacy-specifieke vragen: info@solofix.nl met onderwerp "Privacy"</p>

          <hr className="my-8 border-white/[.08]" />
          <p className="text-sm text-fg-muted italic">Dit privacy statement is onderdeel van het gebruik van Solofix.nl en dient samen met onze Algemene Voorwaarden gelezen te worden.</p>
        </div>

        {/* Footer Navigation */}
        <div className="pt-8 mt-12">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <a href="/" className="sf-link">
              ← Terug naar Solofix
            </a>
            <a href="/algemene-voorwaarden" className="text-fg-muted hover:text-fg-bright transition-colors">
              Bekijk ook onze Algemene Voorwaarden →
            </a>
          </div>
        </div>
    </PublicPageLayout>
  );
};

export default PrivacyPage;